module.exports = __webpack_public_path__ + "img/S5.7ca60ad0.png";